import {toaster} from '@gravity-ui/uikit/toaster-singleton-react-18';
import {ToastProps} from '@gravity-ui/uikit';

export const DEFAULT_TOAST_TIMEOUT = 15000;

interface CreateToast {
    (opts: ToastProps): unknown;
}

const createToast: CreateToast = (opts) => {
    if (!toaster) return;

    toaster.add(opts);
};

export default {
    toaster,
    createToast,
    createSuccessToast: (name: string, title: string, opts?: Partial<ToastProps>) =>
        createToast({
            name,
            title,
            type: 'success',
            autoHiding: DEFAULT_TOAST_TIMEOUT,
            ...opts,
        }),
    createErrorToast: (
        name: string,
        title: string,
        err?: {message?: string},
        opts?: Partial<ToastProps>,
    ) =>
        createToast({
            name,
            title,
            type: 'error',
            autoHiding: DEFAULT_TOAST_TIMEOUT,
            content: err?.message,
            ...opts,
        }),
};
